/** PATCH /users/me may include large base64 images and waits on S3/Clerk; exceeds default prod axios timeout (10s). */
export const USERS_ME_PATCH_TIMEOUT_MS = 90_000;
